import { IoCContainer, IUtils, WebCoreIoCKeys } from '@lmnop/web-core';

export class News {
    public guid: string;
    public title: string;
    public content: string;
    public isRead: boolean = false;
    public className: string;

    constructor(newsItemObj?: any) {
        let utils: IUtils = IoCContainer.get(WebCoreIoCKeys.IUtils);
        if (newsItemObj != null) {
            utils.deepCopy(this, newsItemObj);
        }
    }
}
